import { createFileRoute, Link } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { api } from '../api/client'
import type { ServerSummary } from '../api/client'

export const Route = createFileRoute('/dashboard')({
  component: DashboardPage,
})

function DashboardPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['servers'],
    queryFn: () => api<ServerSummary[]>('/api/servers'),
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold text-zinc-900">MCP servers</h1>
      <p className="mt-1 text-sm text-zinc-600">
        Configure each server with the credentials it needs, then connect it from Claude Desktop.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {isLoading && <div className="text-sm text-zinc-500">Loading…</div>}
        {error && <div className="text-sm text-red-600">{(error as Error).message}</div>}
        {data?.map((s) => (
          <Link
            key={s.slug}
            to="/servers/$slug"
            params={{ slug: s.slug }}
            className="rounded-lg border border-zinc-200 bg-white p-4 hover:border-brand-500 hover:shadow-sm"
          >
            <div className="flex items-center justify-between">
              <div className="font-medium text-zinc-900">{s.name}</div>
              <StatusBadge configured={s.configured} enabled={s.enabled} />
            </div>
            <p className="mt-1 text-sm text-zinc-600">{s.description}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}

function StatusBadge({ configured, enabled }: { configured: boolean; enabled: boolean }) {
  if (!configured) {
    return (
      <span className="rounded-full bg-zinc-100 px-2 py-0.5 text-xs text-zinc-600">
        Not configured
      </span>
    )
  }
  if (!enabled) {
    return (
      <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs text-amber-700">
        Disabled
      </span>
    )
  }
  return (
    <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-xs text-emerald-700">
      Ready
    </span>
  )
}
